import React, { FC, useEffect, useState } from "react"

const getLabelName = (filterType: string) => {
    switch (filterType) {
        case "reg":
            return "Дата заказа"
        case "geo":
            return "Дата заказа"
        case "app":
            return "Дата заказа"
        case "orders":
            return "Дата заказа"
        case "payments":
            return "Дата заказа"
        case "webinar":
            return "Дата заказа"
        case "ads":
            return "Дата заказа"
        default:
            return "Дата заказа"
    }
}

const ChartLabel: FC<any> = ({ chartFilter, isDisabled = false, chartType, width }) => {

    const [ label, setLabel ] = useState("")

    useEffect(() => {
        if (chartFilter) {
            setLabel(getLabelName(chartFilter))
        } else {
            setLabel("")
        }
    }, [ chartFilter ])

    if (chartType !== "line" && chartType !== "area") {
        return null
    }

    return chartFilter && !isDisabled ? (
        <div className="universal-chart-label" style={{ width: "100%" }}>
            <p>
                {label}
            </p>
        </div>
    ) : null
}

export default ChartLabel
